<template>
  <div class="d-flex flex-column gap-4 mt-4">
    <template v-if="latestClosedEvent?.id">
      <div>
        <strong>Reason</strong>
        <p>
          {{
            t(
              `yard.dialogs.yardViewSpotStatusDialog.dropDownItems.${camelCase(
                latestClosedEvent.reason
              )}`,
              latestClosedEvent.reason
            )
          }}
        </p>
      </div>

      <div v-if="latestClosedEvent.observation">
        <strong>{{ t('yard.pages.yardView.headers.additionalNotes') }}</strong>
        <p>{{ latestClosedEvent.observation }}</p>
      </div>

      <div>
        <strong>{{ t('yard.pages.yardView.headers.closedFor') }}</strong>
        <p>
          <v-icon size="x-small" class="mr-1">mdi-clock-outline</v-icon>
          {{ spotClosedFor }}
        </p>
      </div>
    </template>
  </div>
</template>

<script>
import { computed, defineComponent, ref, onMounted, watch } from 'vue';
import useYard from '@/modules/yard/composables/useYard';
import { camelCase } from 'lodash';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'YardViewSpotDetailClosed',
  methods: { camelCase },
  setup() {
    const { t } = useI18n();
    const yardStore = useYard();
    const latestClosedEvent = ref(null);

    const spotClosedFor = computed(() =>
      yardStore.timeElapsedFromWarehouse(latestClosedEvent.value?.createDateTime)
    );

    onMounted(async () => {
      latestClosedEvent.value = await yardStore.getLatestClosedEvent(
        yardStore.selectedSpotRef.value.id
      );
    });

    watch(yardStore.selectedSpotRef, async () => {
      latestClosedEvent.value = await yardStore.getLatestClosedEvent(
        yardStore.selectedSpotRef.value.id
      );
    });

    return {
      t,
      latestClosedEvent,
      spot: yardStore.selectedSpotRef,
      spotClosedFor
    };
  }
});
</script>
